import { render, staticRenderFns } from "./detailPageCommonHeader.vue?vue&type=template&id=c77e7b64&scoped=true"
import script from "./detailPageCommonHeader.vue?vue&type=script&lang=js"
export * from "./detailPageCommonHeader.vue?vue&type=script&lang=js"
import style0 from "./detailPageCommonHeader.vue?vue&type=style&index=0&id=c77e7b64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77e7b64",
  null
  
)

export default component.exports